import React, { useState } from "react";
import { LinkBTNTransport } from "../../LinkBTN";
import taxi from "../../../imgs/Icons/taxi.svg";
import carro from "../../../imgs/Icons/carro.svg";
import metro from "../../../imgs/Icons/metro.svg";
import comboio from "../../../imgs/Icons/comboio.svg";
import autocarro from "../../../imgs/Icons/autocarro.svg";
import {ModalLink} from "../Transportes/modal";
import {Modal} from "../Transportes/modal";
import { withNamespaces } from 'react-i18next';

const Transportes = ({ t }) => {
  const inicialActive = {
    option1: true,
    option2: false,
  };

  const [active, setActive] = useState(inicialActive);
  const toggleMenu = (optionName) => {
    let element_active = {};
    for (const key in active) {
      element_active[key] = key === optionName ? !active[key] : false;
    }
    setActive(element_active);
  };

  return (
    <div className="box-bg">
      <ul className="nav nav-tabs nav-justified" id="myTab" role="tablist">
        <li
          onClick={() => toggleMenu("option1")}
          className={`nav-item ${active.option1 ? "tab-option" : null}`}
          role="presentation"
        >
          <a
            className={`tab-title ${active.option1 ? "active" : null}`}
            id="home-tab"
            data-bs-toggle="tab"
            href="#porto"
            role="tab"
            aria-controls="home"
            aria-selected="true"
          >
            {t('moduleChegadaAveiro:S1.APorto.T')}
          </a>
        </li>
        <li
          onClick={() => toggleMenu("option2")}
          className={`nav-item ${active.option2 ? "tab-option" : null}`}
          role="presentation"
        >
          <a
            className={`tab-title ${active.option2 ? "active" : null}`}
            id="profile-tab"
            data-bs-toggle="tab"
            href="#lisboa"
            role="tab"
            aria-controls="profile"
            aria-selected="false"
          >
            {t('moduleChegadaAveiro:S1.ALisboa.T')}
          </a>
        </li>
      </ul>

      {/* CONTEUDO */}

      <div className="tab-content" id="myTabContent">
        {/* PORTO */}
        <div className={`tab-pane fade ${active.option1 ? "show active" : null} tab-content`} id="porto" role="tabpanel" aria-labelledby="home-tab">
          <div className="row">
            <div>
              <p className="section-title">{t('moduleChegadaAveiro:S1.APorto.TP.Priv.T')}</p>
              <div>
                {/* TAXI-PORTO */}
                <LinkBTNTransport btnName={t('moduleChegadaAveiro:S1.APorto.TP.Priv.Priv1.T')} icon={taxi} iconAlt={t('moduleChegadaAveiro:S1.Alt2.Alt3')} link="#taxip" />
                <Modal id="taxip" icon={taxi} title={t('moduleChegadaAveiro:S1.APorto.TP.Priv.Priv1.T')} text={t('moduleChegadaAveiro:S1.APorto.TP.Priv.Priv1.P1')} euro={t('moduleChegadaAveiro:S1.Alt2.Alt1')} euroText={t('moduleChegadaAveiro:S1.APorto.TP.Priv.Priv1.P2')} time={t('moduleChegadaAveiro:S1.Alt2.Alt2')} timeText={t('moduleChegadaAveiro:S1.APorto.TP.Priv.Priv1.P3')} />

                {/* CARRO-PORTO */}
                <LinkBTNTransport btnName={t('moduleChegadaAveiro:S1.APorto.TP.Priv.Priv2.T')} icon={carro} iconAlt={t('moduleChegadaAveiro:S1.Alt2.Alt4')} link="#carrop" />
                <Modal id="carrop" icon={carro} title={t('moduleChegadaAveiro:S1.APorto.TP.Priv.Priv2.T')} text={t('moduleChegadaAveiro:S1.APorto.TP.Priv.Priv2.P1')} euro={t('moduleChegadaAveiro:S1.Alt2.Alt1')} euroText={t('moduleChegadaAveiro:S1.APorto.TP.Priv.Priv2.P2')} time={t('moduleChegadaAveiro:S1.Alt2.Alt2')} timeText={t('moduleChegadaAveiro:S1.APorto.TP.Priv.Priv2.P3')} />

              </div>
              <div>
                <p className="section-title">{t('moduleChegadaAveiro:S1.APorto.TP.Pub.T')}</p>
                <div>
                  {/* METRO-PORTO */}
                  <LinkBTNTransport btnName={t('moduleChegadaAveiro:S1.APorto.TP.Pub.Pub1.T')} icon={metro} iconAlt={t('moduleChegadaAveiro:S1.Alt2.Alt5')} link="#metrop" />
                  <ModalLink id="metrop" icon={metro} title={t('moduleChegadaAveiro:S1.APorto.TP.Pub.Pub1.T')}
                  text={t('moduleChegadaAveiro:S1.APorto.TP.Pub.Pub1.P1')}
                  link={t('moduleChegadaAveiro:S1.APorto.TP.Pub.Pub1.Link.Link')}
                  linkName={t('moduleChegadaAveiro:S1.APorto.TP.Pub.Pub1.Link.NameLink')}
                  finalText={t('moduleChegadaAveiro:S1.APorto.TP.Pub.Pub1.Link.P')}
                  euro={t('moduleChegadaAveiro:S1.Alt2.Alt1')} euroText={t('moduleChegadaAveiro:S1.APorto.TP.Pub.Pub1.P2')} time={t('moduleChegadaAveiro:S1.Alt2.Alt2')} timeText={t('moduleChegadaAveiro:S1.APorto.TP.Pub.Pub1.P3')} />

                  {/* COMBOIO-PORTO */}
                  <LinkBTNTransport btnName={t('moduleChegadaAveiro:S1.APorto.TP.Pub.Pub2.T')} icon={comboio} iconAlt={t('moduleChegadaAveiro:S1.Alt2.Alt6')} link="#comboiop" />
                  <ModalLink id="comboiop" icon={comboio} title={t('moduleChegadaAveiro:S1.APorto.TP.Pub.Pub2.T')} text={t('moduleChegadaAveiro:S1.APorto.TP.Pub.Pub2.P1')}
                  link={t('moduleChegadaAveiro:S1.APorto.TP.Pub.Pub2.Link.Link')}
                  linkName={t('moduleChegadaAveiro:S1.APorto.TP.Pub.Pub2.Link.NameLink')}
                  finalText={t('moduleChegadaAveiro:S1.APorto.TP.Pub.Pub2.Link.P')} euro={t('moduleChegadaAveiro:S1.Alt2.Alt1')} euroText={t('moduleChegadaAveiro:S1.APorto.TP.Pub.Pub2.P2')} time={t('moduleChegadaAveiro:S1.Alt2.Alt2')} timeText={t('moduleChegadaAveiro:S1.APorto.TP.Pub.Pub2.P3')} />

                  {/* AUTOCARRO-PORTO */}
                  <LinkBTNTransport btnName={t('moduleChegadaAveiro:S1.APorto.TP.Pub.Pub3.T')} icon={autocarro} iconAlt={t('moduleChegadaAveiro:S1.Alt2.Alt7')} link="#autocarrop" />
                  <ModalLink id="autocarrop" icon={autocarro} title={t('moduleChegadaAveiro:S1.APorto.TP.Pub.Pub3.T')} text={t('moduleChegadaAveiro:S1.APorto.TP.Pub.Pub3.P1')}
                  link={t('moduleChegadaAveiro:S1.APorto.TP.Pub.Pub3.Link.Link')}
                  linkName={t('moduleChegadaAveiro:S1.APorto.TP.Pub.Pub3.Link.NameLink')}
                  finalText={t('moduleChegadaAveiro:S1.APorto.TP.Pub.Pub3.Link.P')} euro={t('moduleChegadaAveiro:S1.Alt2.Alt1')} euroText={t('moduleChegadaAveiro:S1.APorto.TP.Pub.Pub3.P2')} time={t('moduleChegadaAveiro:S1.Alt2.Alt2')} timeText={t('moduleChegadaAveiro:S1.APorto.TP.Pub.Pub3.P3')} />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* LISBOA */}
        <div className={`tab-pane fade ${active.option2 ? "show active" : null} tab-content`} id="lisboa" role="tabpanel" aria-labelledby="profile-tab">
          <div className="row">
            <div>
              <p className="section-title">{t('moduleChegadaAveiro:S1.ALisboa.TP.Priv.T')}</p>
              <div>
                {/* TAXI-LISBOA */}
                <LinkBTNTransport btnName={t('moduleChegadaAveiro:S1.ALisboa.TP.Priv.Priv1.T')} icon={taxi} iconAlt={t('moduleChegadaAveiro:S1.Alt2.Alt3')} link="#taxil" />
                <Modal id="taxil" icon={taxi} title={t('moduleChegadaAveiro:S1.ALisboa.TP.Priv.Priv1.T')} text={t('moduleChegadaAveiro:S1.ALisboa.TP.Priv.Priv1.P1')} euro={t('moduleChegadaAveiro:S1.Alt2.Alt1')} euroText={t('moduleChegadaAveiro:S1.ALisboa.TP.Priv.Priv1.P2')} time={t('moduleChegadaAveiro:S1.Alt2.Alt2')} timeText={t('moduleChegadaAveiro:S1.ALisboa.TP.Priv.Priv1.P3')} />

                {/* CARRO-LISBOA */}
                <LinkBTNTransport btnName={t('moduleChegadaAveiro:S1.ALisboa.TP.Priv.Priv2.T')} icon={carro} iconAlt={t('moduleChegadaAveiro:S1.Alt2.Alt4')} link="#carrol" />
                <Modal id="carrol" icon={carro} title={t('moduleChegadaAveiro:S1.ALisboa.TP.Priv.Priv2.T')} text={t('moduleChegadaAveiro:S1.ALisboa.TP.Priv.Priv2.P1')} euro={t('moduleChegadaAveiro:S1.Alt2.Alt1')} euroText={t('moduleChegadaAveiro:S1.ALisboa.TP.Priv.Priv2.P2')} time={t('moduleChegadaAveiro:S1.Alt2.Alt2')} timeText={t('moduleChegadaAveiro:S1.ALisboa.TP.Priv.Priv2.P3')} />
              </div>
            </div>
            <div>
              <p className="section-title">{t('moduleChegadaAveiro:S1.ALisboa.TP.Pub.T')}</p>
              <div>
                {/* METRO-LISBOA */}
                <LinkBTNTransport btnName={t('moduleChegadaAveiro:S1.ALisboa.TP.Pub.Pub1.T')} icon={metro} iconAlt={t('moduleChegadaAveiro:S1.Alt2.Alt5')} link="#metrol" />
                <ModalLink id="metrol" icon={metro} title={t('moduleChegadaAveiro:S1.ALisboa.TP.Pub.Pub1.T')} text={t('moduleChegadaAveiro:S1.ALisboa.TP.Pub.Pub1.P1')}
                  link={t('moduleChegadaAveiro:S1.ALisboa.TP.Pub.Pub1.Link.Link')}
                  linkName={t('moduleChegadaAveiro:S1.ALisboa.TP.Pub.Pub1.Link.NameLink')}
                  finalText={t('moduleChegadaAveiro:S1.ALisboa.TP.Pub.Pub1.Link.P')} euro={t('moduleChegadaAveiro:S1.Alt2.Alt1')} euroText={t('moduleChegadaAveiro:S1.ALisboa.TP.Pub.Pub1.P2')} time={t('moduleChegadaAveiro:S1.Alt2.Alt2')} timeText={t('moduleChegadaAveiro:S1.ALisboa.TP.Pub.Pub1.P3')} />

                {/* COMBOIO-LISBOA */}
                <LinkBTNTransport btnName={t('moduleChegadaAveiro:S1.ALisboa.TP.Pub.Pub2.T')} icon={comboio} iconAlt={t('moduleChegadaAveiro:S1.Alt2.Alt6')} link="#comboiol" />
                <ModalLink id="comboiol" icon={comboio} title={t('moduleChegadaAveiro:S1.ALisboa.TP.Pub.Pub2.T')} text={t('moduleChegadaAveiro:S1.ALisboa.TP.Pub.Pub2.P1')}
                  link={t('moduleChegadaAveiro:S1.ALisboa.TP.Pub.Pub2.Link.Link')}
                  linkName={t('moduleChegadaAveiro:S1.ALisboa.TP.Pub.Pub2.Link.NameLink')}
                  finalText={t('moduleChegadaAveiro:S1.ALisboa.TP.Pub.Pub2.Link.P')} euro={t('moduleChegadaAveiro:S1.Alt2.Alt1')} euroText={t('moduleChegadaAveiro:S1.ALisboa.TP.Pub.Pub2.P2')} time={t('moduleChegadaAveiro:S1.Alt2.Alt2')} timeText={t('moduleChegadaAveiro:S1.ALisboa.TP.Pub.Pub2.P3')} />

                {/* AUTOCARRO-LISBOA */}
                <LinkBTNTransport btnName={t('moduleChegadaAveiro:S1.ALisboa.TP.Pub.Pub3.T')} icon={autocarro} iconAlt={t('moduleChegadaAveiro:S1.Alt2.Alt7')} link="#autocarrol" />
                <ModalLink id="autocarrol" icon={autocarro} title={t('moduleChegadaAveiro:S1.ALisboa.TP.Pub.Pub3.T')} text={t('moduleChegadaAveiro:S1.ALisboa.TP.Pub.Pub3.P1')}
                  link={t('moduleChegadaAveiro:S1.ALisboa.TP.Pub.Pub3.Link.Link')}
                  linkName={t('moduleChegadaAveiro:S1.ALisboa.TP.Pub.Pub3.Link.NameLink')}
                  finalText={t('moduleChegadaAveiro:S1.ALisboa.TP.Pub.Pub3.Link.P')} euro={t('moduleChegadaAveiro:S1.Alt2.Alt1')} euroText={t('moduleChegadaAveiro:S1.ALisboa.TP.Pub.Pub3.P2')} time={t('moduleChegadaAveiro:S1.Alt2.Alt2')} timeText={t('moduleChegadaAveiro:S1.ALisboa.TP.Pub.Pub3.P3')} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withNamespaces()(Transportes);
